import { CalendarDays, Eye, SquareArrowOutUpRight, Zap } from "lucide-react";

import LogoCircle from "@/assets/logo-circle.svg?react";
import MetaLogo from "@/assets/meta-logo.svg?react";
import { AccessibleIcon } from "@/components/accessible-icon";
import { Button } from "@/components/button";
import { Heading } from "@/components/heading";
import { Text } from "@/components/text";

const FEATURES = [
  { icon: CalendarDays, label: "Schedule posts to Instagram & Facebook" },
  { icon: Eye, label: "Preview your carousel posts before publishing" },
  { icon: Zap, label: "Generate copy with AI assistance" },
];

export function ConnectMetaPage({
  isConnecting,
  onConnect,
}: {
  isConnecting: boolean;
  onConnect: () => void;
}) {
  return (
    <main className="flex min-h-full items-center justify-center p-xl">
      <div className="flex w-full max-w-[440px] flex-col items-center gap-3xl rounded-xl border border-border-secondary bg-bg-primary p-3xl shadow-sm">
        <div className="flex items-center gap-lg">
          <AccessibleIcon>
            <LogoCircle className="size-12" />
          </AccessibleIcon>
          <div aria-hidden="true" className="flex gap-xs">
            {[0, 1, 2].map((dot) => (
              <span
                className="size-1.5 rounded-full bg-fg-quaternary"
                key={dot}
              />
            ))}
          </div>
          <AccessibleIcon>
            <MetaLogo className="h-[31px] w-12" />
          </AccessibleIcon>
        </div>

        <div className="flex flex-col gap-sm text-center">
          <Heading className="text-xl font-semibold text-text-primary">
            Connect your Meta account
          </Heading>
          <Text className="text-text-tertiary">
            Your credentials are stored securely and you can disconnect at any
            time from Settings.
          </Text>
        </div>

        <ul className="flex w-full flex-col gap-lg">
          {FEATURES.map(({ icon: Icon, label }) => (
            <li className="flex items-center gap-md" key={label}>
              <AccessibleIcon>
                <Icon className="size-5 shrink-0 text-fg-primary" />
              </AccessibleIcon>
              <Text className="text-text-secondary" elementType="span">
                {label}
              </Text>
            </li>
          ))}
        </ul>

        <div className="flex w-full flex-col items-center gap-md">
          <Button
            className="w-full"
            isLoading={isConnecting}
            onPress={onConnect}
            size="lg"
          >
            Connect with Meta
            <AccessibleIcon>
              <SquareArrowOutUpRight />
            </AccessibleIcon>
          </Button>
          <Text className="text-xs text-text-quaternary">
            You&apos;ll be redirected to Meta to authorize access
          </Text>
        </div>
      </div>
    </main>
  );
}
